import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  bold: { fontWeight: 500 },
}));
